import * as Sentry from '@sentry/angular';

export const IGNORED_ERROR_MESSAGES = [
  'Non-Error promise rejection captured with value',
  'Non-Error exception captured with keys',
  'Object captured as exception with keys',
  'captured as promise rejection',
  'Timeout has occurred',
  'The remote server machine does not exist or is unavailable',
  'NetworkError',
  'network error',
  'NETWORK_ERR',
  'Server returned code 502 with body',
  'Server returned code 504 with body',
  'Server returned code 503 with body',
  'Server returned code 400 with body',
  'Error in input stream',
  'Http failure',
  'Failed to fetch',
  'No error message',
  '_avast_submit',
  'change_ua',
  '_logicalFormForControl',
  '_convertKeyframesToObject',
  'ChunkLoadError',
  'Load failed',
  'SecurityError',
  'The operation is insecure',
  'Java exception was raised during method invocation',
  'Java object is gone',
  'Error: not implemented',
  'Notifications are not allowed for this application',
  'plugin is not implemented on ios',
  'Impossibile comunicare con un’applicazione di supporto',
  'Failed to start the audio device',
  'Unable to display URL',
  'while retrieving PDF',
  'PDFViewerApplication',
  'assets/viewer',
  'assets/pdf',
  'Invalid call to runtime.sendMessage',
  'window.webkit.messageHandlers',
  'requestAnimationFrame',
  'queueMicrotask is not defined',
  'Importing a module script failed',
  "evaluating 'e.webkitEnterFullscreen'",
  "evaluating 'localStorage.getItem'",
  "Can't find variable: EmptyRanges",
  `pusher subscription error`,
  `pusher connection error`,
];

// volontairement plus large que `denyUrls`, qui ne teste que l'url de la dernière frame : ici une seule
// frame de la stack suffit à écarter l'événement
const IGNORED_FRAME_PATTERNS = [
  'assets/pdf',
  'assets/viewer',
  'assets/op-chaining-support',
  'ngx-extended-pdf-viewer',
  'lottie-web',
  '@intercom/messenger-js-sdk',
  'tinymce',
  'h0.js',
];

const IGNORED_FRAME_FUNCTIONS = ['openPDF', 'onPdfJsInit'];

export function filterSentryEvent(event: Sentry.ErrorEvent): Sentry.ErrorEvent | null {
  const topLevelFrames = (event as { stacktrace?: Sentry.Stacktrace }).stacktrace?.frames ?? [];
  const exceptionFrames = (event.exception?.values ?? []).flatMap(
    (exception) => exception.stacktrace?.frames ?? []
  );

  const comesFromIgnoredLibrary = [...topLevelFrames, ...exceptionFrames].some(
    (frame) =>
      IGNORED_FRAME_PATTERNS.some(
        (pattern) => frame.module?.includes(pattern) || frame.filename?.includes(pattern)
      ) || IGNORED_FRAME_FUNCTIONS.some((name) => frame.function?.includes(name))
  );

  return comesFromIgnoredLibrary ? null : event;
}
